import UtilService from 'services/util';

import { isEmpty } from 'util/utils';

import { API_ROUTES } from 'constants/CommonApi';

export const getSellerList = (request = {}, config = { loader: false }) =>
  UtilService.callApiAsync({ ...API_ROUTES.Seller.paginate, request, ...(!isEmpty(config) && { config }) });
